module.exports = __webpack_public_path__ + "img/logo.d41af2d8.png";